// Fittechs product page: gallery (photos + videos), mood preview, variant picker, quantity / pack picker, AJAX add to cart, mobile sticky bar.
(function () {
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function init(root) {
    var stageWrap = root.querySelector('[data-ftp-stage]');
    var stage = root.querySelector('[data-ftp-stage] img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ftp-thumb]'));
    var count = root.querySelector('[data-ftp-count]');
    var index = 0;
    var media = [];
    var vid = null;

    function hideVideo() {
      if (vid) { vid.pause(); vid.style.display = 'none'; }
      if (stage) stage.style.visibility = 'visible';
    }
    function showVideo(m) {
      var srcs = (m.sources || []).filter(function (s) { return s.format === 'mp4' || /mp4/.test(s.mime_type || ''); });
      if (!srcs.length || !stageWrap) return false;
      srcs.sort(function (a, b) { return (b.height || 0) - (a.height || 0); });
      var pick = srcs.filter(function (s) { return (s.height || 0) <= 1080; })[0] || srcs[srcs.length - 1];
      if (!vid) {
        vid = document.createElement('video');
        vid.setAttribute('playsinline', '');
        vid.setAttribute('controls', '');
        vid.muted = true; vid.loop = true; vid.autoplay = true;
        vid.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#000;z-index:1';
        stageWrap.appendChild(vid);
      }
      if (vid.getAttribute('src') !== pick.url) vid.src = pick.url;
      if (m.preview_image && m.preview_image.src) vid.poster = m.preview_image.src;
      vid.style.display = 'block';
      if (stage) stage.style.visibility = 'hidden';
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
      return true;
    }
    function show(src, alt) {
      hideVideo();
      if (!stage || !src) return;
      stage.removeAttribute('srcset');
      stage.style.opacity = '0.3';
      stage.onload = function () { stage.style.opacity = '1'; };
      stage.src = src;
      if (alt) stage.alt = alt;
    }
    function go(i) {
      if (!thumbs.length) return;
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      var m = media[index];
      if (!(m && m.media_type === 'video' && showVideo(m))) show(t.dataset.src, t.dataset.alt);
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      if (count) count.textContent = (index + 1) + ' / ' + thumbs.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-ftp-prev]');
    var next = root.querySelector('[data-ftp-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    [prev, next, count].forEach(function (el) { if (el) el.style.zIndex = '2'; });
    var startX = null;
    if (stageWrap && thumbs.length > 1) {
      stageWrap.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      stageWrap.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
        startX = null;
      }, { passive: true });
    }
    // Load media types (photo / video) for this product so video thumbnails play.
    var path = location.pathname.replace(/\/$/, '');
    if (/\/products\//.test(path) && thumbs.length) {
      fetch(path + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.media) return;
          media = p.media;
          media.forEach(function (m, i) {
            if (m.media_type === 'video' && thumbs[i]) {
              thumbs[i].style.position = 'relative';
              thumbs[i].insertAdjacentHTML('beforeend', "<span aria-hidden='true' style='position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none'><span style='width:26px;height:26px;border-radius:50%;background:rgba(0,0,0,.6);color:#fff;font-size:11px;display:flex;align-items:center;justify-content:center;padding-left:2px'>▶</span></span>");
              thumbs[i].setAttribute('aria-label', 'Play video ' + (i + 1));
            }
          });
          if (media[0] && media[0].media_type === 'video') go(0);
        })
        .catch(function () {});
    }

    // Mood picker
    var moodDesc = root.querySelector('[data-ftp-mood-desc]');
    var moodName = root.querySelector('[data-ftp-mood-name]');
    var moodImg = root.querySelector('[data-ftp-mood-img]');
    var moodPic = root.querySelector('.ftp-moodpic');
    root.querySelectorAll('[data-ftp-mood]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-ftp-mood]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (btn.dataset.src) show(btn.dataset.src, btn.dataset.name + ' glow');
        if (moodImg && btn.dataset.thumb) { moodImg.src = btn.dataset.thumb; moodImg.alt = btn.dataset.name + ' glow'; }
        if (moodName) moodName.textContent = btn.dataset.name || '';
        if (moodDesc) moodDesc.textContent = btn.dataset.desc || '';
        if (moodPic) { moodPic.classList.remove('is-flash'); void moodPic.offsetWidth; moodPic.classList.add('is-flash'); }
      });
    });

    var qty = root.querySelector('[data-ftp-qty]');
    var idInput = root.querySelector('[data-ftp-id]');
    var atc = root.querySelector('[data-ftp-atc]');
    var atcText = root.querySelector('[data-ftp-atc-text]');
    var unit = atc ? Number(atc.dataset.price || 0) : 0;
    var hasPacks = !!root.querySelector('[data-ftp-pack]');
    function setLabels(text) { root.querySelectorAll('[data-ftp-price-label]').forEach(function (l) { l.textContent = text; }); }
    function refreshTotal() {
      if (hasPacks) return;
      var n = Number(qty ? qty.value : 1);
      setLabels(money(unit * n));
      var pr = root.querySelector('.ftp-pricerow [data-ftp-price-label]');
      if (pr) pr.textContent = money(unit);
    }

    var vName = root.querySelector('[data-ftp-variant-name]');
    root.querySelectorAll('[data-ftp-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-ftp-variant]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (idInput) idInput.value = btn.dataset.id;
        if (vName) vName.textContent = btn.dataset.name;
        unit = Number(btn.dataset.price || unit);
        if (btn.dataset.img) show(btn.dataset.img, btn.dataset.name);
        var stockN = root.querySelector('[data-ftp-stock-n]');
        if (stockN && btn.dataset.stock) stockN.textContent = btn.dataset.stock;
        var ok = btn.dataset.available === 'true';
        if (atc && atcText) {
          atc.disabled = !ok;
          atcText.innerHTML = ok ? 'Add to cart · <span data-ftp-price-label></span>' : 'Sold out';
        }
        refreshTotal();
        if (!ok) setLabels(money(unit));
      });
    });

    var qShow = root.querySelector('[data-ftp-qty-show]');
    root.querySelectorAll('[data-ftp-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.min(10, Math.max(1, Number(qty.value) + Number(b.dataset.ftpQtyBtn)));
        qty.value = n;
        if (qShow) qShow.textContent = n;
        refreshTotal();
      });
    });

    root.querySelectorAll('[data-ftp-pack]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-ftp-pack]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (qty) qty.value = btn.dataset.qty || 1;
        setLabels(btn.dataset.label);
        root.querySelectorAll('[data-ftp-compare-label]').forEach(function (l) { l.textContent = btn.dataset.compare || ''; });
        root.querySelectorAll('[data-ftp-off]').forEach(function (l) { l.textContent = btn.dataset.off || '0'; });
      });
    });

    var form = root.querySelector('[data-ftp-form]');
    var err = root.querySelector('[data-ftp-err]');
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (form && atc) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc.disabled && !atc.dataset.busy) return;
        if (err) err.hidden = true;
        atc.disabled = true; atc.dataset.busy = '1';
        var id = idInput ? idInput.value : form.querySelector('[name="id"]').value;
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty ? qty.value : 1) }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { window.location.href = base + 'cart'; })
          .catch(function () { atc.disabled = false; delete atc.dataset.busy; if (err) err.hidden = false; });
      });
    }

    var sticky = root.querySelector('[data-ftp-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }).observe(atc);
    }
    root.querySelectorAll('[data-ftp-buy]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!form || atc.disabled) return;
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    });
  }
  function boot() { document.querySelectorAll('[data-ftp-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();